module.exports = __webpack_public_path__ + "static/media/companion-cube-hat.b64d0199.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/companion-cube-hat.png
// module id = 30
// module chunks = 0